// extracted by mini-css-extract-plugin
export default {"redPoint":"navbar_redPoint__qj7kq"};